import { useState } from "react";
import { MolliePage, openMolliePage } from "api/mollieNavigation";
import { Severity } from "Contexts/RestaurantContext";
import useToast from "./useToast";

export default function useMollieNavigation() {
    const [opening, setOpening] = useState(false);
    const toast = useToast();

    const open = async (
        restaurantId: string,
        page: MolliePage,
        newTab = false
    ) => {
        setOpening(true);
        try {
            await openMolliePage(restaurantId, page, newTab);
        } catch {
            toast(
                "Could not open Mollie. Please try again.",
                Severity.ERROR,
                "settings"
            );
        } finally {
            setOpening(false);
        }
    };

    return { open, opening };
}
